export default __webpack_public_path__ + "static/media/headerLogo.358b1599.png";